<template>
  <section class="column-model-edit-container content-detail-container">
    <section class="content-wrap">
      <header v-if="headers.length >0">
        <template v-for="(item, index) in headers">
          <div :key="index" class="header-button">
            <el-link
              v-if="item.icon"
              :disabled="isDisabled(item)"
              :underline="false"
              @click="handleHeaderButton(item)"
            >
              <jee-icon :iconClass="item.icon"/>{{item.label}}
            </el-link>
          </div>
        </template>
        <el-popover
          popper-class="ct-pover header-button"
          placement="bottom"
          trigger="hover"
          :appendToBody='false'
          v-if="detail.id&&popverBtns.length > 0&&showHandle"
        >
          <div class="ct-pover__box">
            <el-link
              class="ct-pover__item jee-hover-color"
              v-for="(info,infoIndex) in popverBtns"  :key="infoIndex"
              :underline="false"
              :disabled="isDisabled(info)"
              @click="handleEvent(info.type,info)"
            >
            <jee-icon
              :iconClass="info.icon"
              class="jee-hover-fill "
              :style="{fontSize:'12px'}"
              v-if="info.icon"></jee-icon>
              {{info.name}}
            </el-link>
          </div>
          <i  slot="reference"
            class="jee-hover-color t-gray el-icon-more"
            :style="{margin:'0 20px',cursor: 'pointer'}" ></i>
        </el-popover>
        <el-button class="full-screen" type="empty" size="small" @click="handleClickScreenFull">
          <jee-icon :iconClass="isFullscreen?'huanyuanhuabu':'quanping'"></jee-icon>
          {{$t(isFullscreen? 'global.cancelScreenFull':'global.screenFull')}}
        </el-button>
      </header>
      <el-form
        label-width="auto"
        label-suffix="："
        ref="form"
        v-loading="loading"
        :model="form"
      >
        <div class="content-form-item-wrap">
          <!-- 标题正文区 -->
          <div class="title-content-wrap">
            <div class="title-wrap">
              <!-- 标题拖拽区 -->
                <template v-for="(item, index) in titleFormItems">
                  <component :key="index" :is="item.preview"
                  :index="index" :option="item.value"
                  :form="form" v-model="form[item.value.name]"
                  />
                </template>
            </div>
            <div class="content-wrap">
              <!-- 正文拖拽区 -->
                <el-tabs type="card" v-model="activeContentTab" @tab-click="handleClickContentTab">
                  <template v-for="(item, index2) in contentFormItems">
                    <el-tab-pane :label="item.tabLabel" :name="item.tabName" :key="index2">
                        <component :is="item.preview" :index="index2" :ref="item.tabName" :key="index2" :option="item.value" :form="form" v-model="form[item.value.name]"></component>
                    </el-tab-pane>
                  </template>
                </el-tabs>
            </div>
          </div>
          <!-- 属性拖拽区 -->
          <div class="base-extend-wrap">
            <el-collapse accordion value="Base">
              <template v-for="(tab, index) in tabs">
                <el-collapse-item :title="tab.label" :name="tab.name" :key="index">
                  <el-form-item v-if="tab.name === 'Base'"
                  class="column-form-item sm-height" prop='modelName' label='内容模型'>
                    <span>{{form.modelName}}</span>
                  </el-form-item>
                  <template v-for="(item, index2) in arrtFormItems[tab.name]">
                    <component :key="index2" :is="item.preview"
                      :getContentText="getContentText"
                      :index="index2" :option="item.value"
                      :form="form" v-model="form[item.value.name]"
                    />
                  </template>
                </el-collapse-item>
              </template>
            </el-collapse>
          </div>
        </div>
      </el-form>
      <form-dialog
        ref="editDialog"
        v-bind="edit"
        @handleConfirm="handleConfirmEdit"
        @handleChangeCascader="handleChangeCascader"
      >
      </form-dialog>
      <sort-content ref="sortContent" :channelIds="[channelId]"
        @getSort="getSort" key="contentEdit"></sort-content>
      <edition ref="edition" @setEdition="setEdition"></edition>
      <operatio-records ref="operatio"></operatio-records>
      <relevant-contents ref="relevant"></relevant-contents>
    </section>
  </section>
</template>
<script>
import formDialog from '@/components/mixins/formDialog'
import baseHeader from '@/components/mixins/baseHeader'
import tableDialog from '@/components/mixins/tableDialog'
import PreviewComponents from '@/components/draggable/Preview/components'
import screenFull from '@/components/mixins/screenFull'
import edition from './detailCompoents/Edition'
import operatioRecords from './detailCompoents/operatioRecords'
import relevantContents from './detailCompoents/RelevantContents'
import mixins from './components/mixins'
import sortContent from './components/sortContent'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'contentDetail',
  components: {
    sortContent,
    edition,
    relevantContents,
    operatioRecords,
    ...PreviewComponents
  },
  mixins: [screenFull, mixins, formDialog, tableDialog, baseHeader],
  inject: ['removeTab'],
  data () {
    var popverBtns = [
      {
        name: '置顶',
        type: 'Istop',
        power: 'topContentAble',
        icon: 'zhiding'
      },
      {
        name: '复制',
        type: 'Copy',
        power: 'copyContentAble',
        icon: 'fuzhilaiyuanlangmu'
      },
      {
        name: '引用',
        type: 'Quote',
        power: 'quoteContentAble',
        icon: 'yinyong'
      },
      {
        name: '排序',
        type: 'Sort',
        power: 'sortContentAble',
        icon: 'paixu1'
      },
      {
        name: '相关内容',
        type: 'Relevant',
        power: 'editContentAble',
        icon: 'neirongguanli'
      },
      // {
      //   name: '浏览记录',
      //   type: 'Browse',
      //   power: 'editContentAble',
      //   icon: 'liulan'
      // },
      {
        name: '推送到站群',
        type: 'Pushstation',
        power: 'sitePushContentAble',
        icon: 'tuisongdaozhanqun',
        disabled: !this._checkPermission('/admin/content/push/sites', 'PUT')
      },
      {
        name: '推送到微信',
        type: 'Pushweixin',
        power: 'wechatPushContentAble',
        icon: 'tuisongdaoweixin',
        disabled: !this._checkPermission('/admin/contentext/push', 'POST')
      },
      {
        name: '推送到微博',
        type: 'Pushweibo',
        power: 'weiboPushContentAble',
        icon: 'tuijiandaoweibo',
        disabled: !this._checkPermission('/admin/weiboarticlepush', 'POST')
      }
    ]
    return {
      showHandle: true,
      loading: false,
      form: {},
      detail: {},
      contentId: '',
      channelId: '',
      hasWorkflow: false,
      tabs: [
        {
          label: '基本属性',
          name: 'Base'
        },
        {
          label: '扩展设置',
          name: 'Extend'
        }
      ],
      screenFullElement: '.content-wrap',
      headers: [],
      activeContentTab: '',
      popverBtns: popverBtns,
      bttons: [
        {
          name: '1',
          label: '存为初稿',
          icon: 'baocun',
          power: 'editContentAble',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '2',
          label: '发布',
          power: 'publishContentAble',
          icon: 'fabu',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '3',
          label: '存为草稿',
          power: 'editContentAble',
          icon: 'cunweicaogao',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '4',
          label: '待发布',
          power: 'editContentAble',
          icon: 'daifabu',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '5',
          label: '预览',
          power: 'editContentAble',
          icon: 'yulang',
          disabled: false
        },
        {
          name: '6',
          label: '浏览',
          power: 'editContentAble',
          icon: 'liulan',
          disabled: false
        },
        {
          name: '7',
          label: '版本',
          power: 'editContentAble',
          icon: 'banben',
          disabled: false
        },
        {
          name: '8',
          label: '操作记录',
          power: 'editContentAble',
          icon: 'caozuojilu',
          disabled: false
        },
        {
          name: '12',
          label: '提交审核',
          power: 'publishContentAble',
          icon: 'shenhe',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '13',
          label: '下线',
          power: 'publishContentAble',
          icon: 'xiaxian',
          disabled: !this._checkPermission('/admin/contentext/status', 'POST')
        },
        {
          name: '14',
          label: '归档',
          power: 'fileContentAble',
          icon: 'guidang',
          disabled: !this._checkPermission('/admin/contentext/status', 'POST')
        },
        {
          name: '15',
          label: '删除',
          power: 'deleteContentAble',
          icon: 'delete',
          disabled: !this._checkPermission('/admin/contentext', 'DELETE')
        },
        {
          name: '16',
          label: '出档',
          power: 'editContentAble',
          icon: 'chudang',
          disabled: !this._checkPermission('/admin/contentext/file', 'POST')
        },
        {
          name: '17',
          label: '撤回(撤回后为初稿状态)',
          power: 'editContentAble',
          icon: 'huanyuan',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        }
      ],
      timer: null
    }
  },
  computed: {
    ...mapGetters(['siteExtendConfig']),
    contentAutoSave () {
      try {
        return this.siteExtendConfig.cfg.contentAutoSave
      } catch (error) {
        return '0'
      }
    },
    contentCommitAllowUpdate () {
      let { contentCommitAllowUpdate } = this.siteExtendConfig.cfg
      return contentCommitAllowUpdate
    },
    titleFormItems () {
      let formItems = []
      if (this.detail && this.detail.renderingField) {
        formItems = this.detail.renderingField.formListTitle || []
      }
      return formItems.sort((a, b) => a.index - b.index)
    },
    contentFormItems () {
      let formItems = []
      if (this.detail && this.detail.renderingField) {
        formItems = this.detail.renderingField.formListContent || []
      }
      return formItems.sort((a, b) => a.index - b.index)
    },
    baseFormItems () {
      let formItems = []
      if (this.detail && this.detail.renderingField) {
        formItems = this.detail.renderingField.formListBase || []
      }
      return formItems.sort((a, b) => a.index - b.index)
    },
    extendFormItems () {
      let formItems = []
      if (this.detail && this.detail.renderingField) {
        formItems = this.detail.renderingField.formListExtend || []
      }
      return formItems.sort((a, b) => a.index - b.index)
    },
    arrtFormItems () {
      return {
        Base: this.baseFormItems,
        Extend: this.extendFormItems
      }
    },
    formItems () {
      return [...this.titleFormItems, ...this.contentFormItems, ...this.baseFormItems, ...this.extendFormItems]
    },
    getFormData () {
      let data = {
        json: {}
      }
      Object.keys(this.form).forEach(d => {
        const item = this.formItems.find(f => f.value.name === d)
        if (item) {
          if (!item.isCustom) data[d] = this.form[d]
          else data.json[d] = this.form[d]
        } else {
          data[d] = this.form[d]
        }
      })
      return data
    }
  },
  watch: {
    contentAutoSave () {
      this.handleAutoSave()
    }
    // detail: {
    //   deep: true,
    //   handler (newData) {
    //     if (newData) {
    //       const { id, dataField, renderingField } = newData
    //       let detailForm = Object.assign({}, { id }, dataField, this.form)
    //       // if(dataField){
    //       //   {}, { id }, this.form
    //       // }
    //       const fieldKeys = Object.keys(renderingField || {})
    //       if (this.$route.query.type === 'link' || this.$route.query.type === 'Link') {
    //         this.channelId = dataField.channelId
    //         this.getChannlWrokflow(dataField.channelId)
    //       }
    //       if (fieldKeys.length) {
    //         fieldKeys.forEach(field => {
    //           const items = renderingField[field]
    //           if (items instanceof Array && items.length) {
    //             items.forEach(item => {
    //               if (!(item.value.name in detailForm)) {
    //                 detailForm[item.value.name] = item.value.defaultValue
    //               }
    //             })
    //           }
    //         })
    //       }
    //       if ('channelId' in detailForm && this.$route.query.type === 'add') {
    //         detailForm.channelId = Number(this.channelId)
    //       }
    //       this.form = detailForm
    //     }
    //   }
    // }
  },
  methods: {
    ...mapActions('config', ['FetchSiteExtentConfig']),
    handleAutoSave () {
      if (this.contentAutoSave === '1') {
        if (!this.timer) {
          this.timer = setInterval(() => {
            this.$refs.form.validate(valid => {
              if (valid) {
                this.getFormData.type = 1
                this.$request.fetchContentUpdate(this.getFormData).then(res => {
                  if (res.code === 200) {
                    this._messageSuccess('autoSave')
                  }
                })
              }
            })
          }, 10000)
        }
      } else {
        this.handleClearInterval()
      }
    },
    getSort (status) {
      if (status) {
        this.fetchContentDetail()
      }
    },
    setEdition (status) {
      if (status) {
        this.fetchContentDetail()
      }
    },
    // 切换预览区标签
    handleMouseOverTabs (e) {
      if (/el-tabs__item/.test(e.target.className)) {
        const id = e.target.id.substr(4)
        this.currentTab = id
        this.labelWidth = ''
        this.$nextTick(() => {
          this.labelWidth = 'auto'
        })
      }
    },
    setDefaultContentTab () {
      try {
        this.activeContentTab = this.contentFormItems[0].tabName
      } catch (error) {}
    },
    handleClickContentTab (tab, e) {
      this.activeContentTab = tab.name
    },
    // 获取当前正文文本内容
    getContentText () {
      try {
        return this.$refs[this.activeContentTab][0].$refs.editor.getText()
      } catch (error) {
        return ''
      }
    },
    setForm () {
      let that = this
      if (this.detail) {
        const { id, modelName, dataField, renderingField } = this.detail
        let detailForm = Object.assign({}, { id, modelName }, dataField)
        const fieldKeys = Object.keys(renderingField || {})
        if (this.$route.query.type === 'link' || this.$route.query.type === 'Link') {
          this.channelId = dataField.channelId
          this.getChannlWrokflow(dataField.channelId)
        }
        if (fieldKeys.length) {
          fieldKeys.forEach(field => {
            const items = renderingField[field]
            if (items instanceof Array && items.length) {
              items.forEach(item => {
                if (!(item.value.name in detailForm)) {
                  detailForm[item.value.name] = item.value.defaultValue
                }
              })
            }
          })
        }
        if ('channelId' in detailForm && this.$route.query.type === 'add') {
          detailForm.channelId = Number(this.channelId)
        }
        this.form = detailForm
        this.getContentBtn(this.detail, that)
      }
    },
    // 获取详情
    fetchContentDetail () {
      this.loading = true
      this.$request.fetchContentDetail(this.contentId).then(res => {
        if (res.code === 200) {
          this.detail = Object.assign({}, res.data)
          this.setForm()
          this.setDefaultContentTab()
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 表格弹窗数据回调
    fetchTableDialogCallBack (res) {
      if (res.code === 200) {
        this.tablelist.data = res.data.content.map(v => {
          return v.cmsContent
        })
        this.tablelist.totalCount = res.data.totalElements
      }
    },
    // 保存
    handleSubmit (e, btn) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          this.$request.fetchContentUpdate(this.getFormData).then(res => {
            if (res.code === 200) {
              this._messageSuccess('save')
              this.removeTab(this.$route.fullPath)
              this.$routerLink('/content/index', 'list')
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 头部按钮点击
    handleHeaderButton (item) {
      switch (item.name) {
        case '1':
          this.getFormData.type = 2
          this.handleSubmit()
          break
        case '2':
          this.getFormData.type = 5
          const { releaseTime, offlineTime } = this.form
          if (offlineTime) {
            if (releaseTime && offlineTime < releaseTime) {
              this.$message.error('下线时间小于发布时间时不能发布')
              break
            } else if (new Date(offlineTime) < new Date()) {
              this.$message.error('下线时间小于当前时间时不能发布')
              break
            }
          }
          this.handleSubmit()
          break
        case '3':
          this.getFormData.type = 1
          this.handleSubmit()
          break
        case '4':
          this.getFormData.type = 4
          this.handleSubmit()
          break
        case '5':
          // 预览
          if (this.detail.previewUrl) {
            window.open(this.detail.previewUrl)
          } else {
            this.$message('没有预览地址')
          }
          break
        case '6':
          // 浏览
          if (this.detail.url) {
            window.open(this.detail.url)
          } else {
            this.$message('没有浏览地址')
          }
          break
        case '7':
          this.$refs['edition'].showTheDialog(item)
          break
        case '8':
          this.$refs['operatio'].showTheDialog(this.contentId)
          break
        case '12':
          // 审核
          this.getFormData.type = 3
          this.$refs.form.validate(valid => {
            if (valid) {
              this.loading = true
              this.$request.fetchContentSubmit(this.getFormData).then(res => {
                this.$restBack(res, () => {
                  this.removeTab(this.$route.fullPath)
                  this.$routerLink('/content/index', 'list')
                }, '提交成功')
                this.loading = false
              }).catch(() => {
                this.loading = false
              })
            } else {
              console.log('error submit!!')
              return false
            }
          })
          break
        case '13':
          // 下线
          this.changeStatus([this.form.id], 7)
          // this.getFormData.type = 7
          // this.handleSubmit()
          break
        case '14':
          // 归档
          this.handleEventFile([this.form.id])
          break
        case '15':
          // 删除
          this.handleEventDelete([this.form.id])
          break
        case '16':
          // 出档
          this.handleEventFileout([this.form.id])
          break
        case '17':
          // 撤回
          this.$request.fetchContentTaskRevoke({ contentId: this.form.id }).then(res => {
            this.$restBack(res, () => {
              this.fetchContentDetail()
            })
          })
          break
        default:
          break
      }
    },
    // 右侧弹出层
    handleEvent (type, btn) {
      this.handleEventAll([this.form.id], btn)
    },
    // 右侧按钮点击
    handleEventRelevant (data, btn) {
      this.$refs['relevant'].showTheDialog(this.contentTree, data[0])
    },
    // handleEventBrowse (data, btn) {
    //   // var ids = data
    // },
    // 是否工作流
    getChannlWrokflow (id) {
      let params = {
        id: id
      }
      this.$request.fetchChannelWorkflowBeing(params).then((res) => {
        if (res.code === 200) {
          this.hasWorkflow = res.data
          this.setHeaderBths(res.data)
        }
      })
    },
    getContentBtn (detail, that) {
      if (that.popverBtns !== 'undefined' && that.popverBtns.length === 8) {
        that.$request.fetchContentTypePage().then(res => {
          if (res.code === 200) {
            var arr = res.data.content
            var btns = Object.assign([], that.popverBtns)
            if (arr instanceof Array && detail.contentTypes instanceof Array) {
              var obj = {}
              arr.forEach(v => {
                obj = detail.contentTypes.find(d => d.id === v.id)
                if (obj) {
                  btns.splice(4, 0, {
                    name: '取消' + v.typeName,
                    id: v.id,
                    // disabled: !obj.operation,
                    type: 'Custom',
                    addType: 'cancel',
                    power: 'typeContentAble',
                    logoId: v.logoId,
                    img: v.logoResource ? that.$getPath(v.logoResource.url) : ''
                  })
                } else if (!obj) {
                  btns.splice(4, 0, {
                    name: v.typeName,
                    id: v.id,
                    power: 'typeContentAble',
                    type: 'Custom',
                    addType: 'o',
                    logoId: v.logoId,
                    img: v.logoResource ? that.$getPath(v.logoResource.url) : ''
                  })
                }
              })
              if (that.popverBtns && that.popverBtns.length === 8) {
                that.popverBtns = btns.map(t => {
                  if (that.form.status === 3) {
                    t.disabled = true
                  }
                  return t
                })
              }
            }
          }
        })
      } else {
        return false
      }
    },
    // 头部按钮显示
    setHeaderBths (status) {
      // 内容状态(1:草稿; 2-初稿 3:流转中; 4:已审核; 5:已发布; 6:驳回; 7:下线 8-归档; 9:暂存;)
      let type = parseInt(this.form.status) || 1
      let arr = []
      let btns = []
      if (type === 8) {
        arr = ['16']
        this.showHandle = false
      } else if (type === 5) {
        let str = status ? '12,1,3,13,14,15,5,6,7,8' : '1,2,3,13,14,15,5,6,7,8'
        let str2 = '13,14,15,5,6,7,8'
        arr = this.contentCommitAllowUpdate === '1' ? str.split(',') : str2.split(',')
      } else {
        this.showHandle = true
        if (status) {
        // 工作流
          btns = ['12,1,3,14,15', '12,1,3,14,15', '17', '12,1,3,14,15', '12,1,3,13,14,15', '12,1,3,14,15', '12,1,2,3,14,15', '16']
          arr = (btns[type - 1] + ',5,7,8').split(',')
        } else {
        // 非工作流
          btns = ['1,2,3,14,15', '1,2,3,14,15', '', '1,2,3,14,15', '1,2,3,13,14,15', '', '1,2,3,14,15', '16']
          arr = (btns[type - 1] + ',5,7,8').split(',')
        }
      }

      this.headers = arr.map(v => {
        let t = this.bttons.find(d => d.name === v)
        return t
      })
      // revokeSupport 内容是否可撤回
      if (!this.detail.revokeSupport && this.headers.find(d => d.name === '17')) {
        this.headers.find(d => d.name === '17').disabled = true
      } else if (this.headers.find(d => d.name === '17')) {
        this.headers.find(d => d.name === '17').disabled = false
      }
      if (this.detail.actions instanceof Array && this.detail.actions.length > 0) {
        let actions = this.detail.actions.map(v => {
          v.label = v.actionName
          return v
        })
        this.headers.unshift(actions)
      }
    },
    getFormDatas () {
      const { id, channelId, type } = this.$route.query
      this.fetchContentList()
      if (type === 'add' && channelId) {
        this.channelId = channelId
        this.getChannlWrokflow(channelId)
      }
      if (id && id !== String(this.contentId)) {
        this.contentId = id ? Number(id) : ''
        this.fetchContentDetail()
      }
    },
    isDisabled (data) {
      if (data.disabled) {
        return true
      } else if (this.$route.query.type !== 'add' && this.detail) {
        if (this.detail.purview) {
          return !this.detail.purview[data.power]
        } else {
          return false
        }
      } else {
        return false
      }
    },
    handleClearInterval () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  mounted () {
    this.FetchSiteExtentConfig()
    this.handleAutoSave()
    this.$nextTick(() => {
      const { id } = this.$route.query
      this.getFormDatas()
      if (id) {
        this.FetchWechatInfoPage()
        this.GetOwnerTrees()
        this.FetchSiteExtentConfig(this.currentSiteId)
      }
    })
  },
  activated () {
    this.getFormDatas()
    this.handleAutoSave()
  },
  deactivated () {
    this.handleClearInterval()
  },
  beforeDestroy () {
    this.handleClearInterval()
  }
}
</script>
<style lang="scss" >
@import '@/views/System/Model/detail.scss';
.ct-pover{
    padding: 0 !important;
    min-width: 135px !important;
    &__box{
      padding:8px 0;
    }
    &__item{
      padding: 0 12px !important;
      line-height: 28px;
      color: #666666 ;
      display: block !important;
      .jee-svg-icon{
          fill: #666;
          margin-right: 8px;
        }
      &:hover{
        background-color: #F3F3F3;
      }
    }
  }
.content-detail-container{
  background-color: #ffffff;

  .el-main{
    overflow-x: hidden;
  }
  .content-wrap{
    background-color: #ffffff;
    // height: 100%;
    // overflow-x: hidden;
    // overflow-y: auto;
    >header{
      background: #F1F0F0;
      height: 58px;
      width: 1280px;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      padding-left: 16px;
      align-items: center;
      .header-button{
        color: #666666;
        .jee-svg-icon{
          fill: #777777;
          padding-right: 7px;
        }
      }
      .el-button .jee-svg-icon{
        padding-right: 10px;
      }
      .header-button + .header-button,
      .header-button + .el-button{
        margin-left: 40px;
      }
      .full-screen{
        background-color: #F1F0F0;
        padding: 8px 20px;
      }
    }
    >.el-form{
      height: calc(100% - 60px);
      overflow-y: auto;
    }
    .content-form-item-wrap{
      padding-top: 20px;
      display: flex;
      justify-content: center;
      .title-content-wrap{
        width: 900px;
        margin-right: 20px;
        .title-wrap{
          padding: 0 22px 0 16px;
          margin-bottom: 20px;
          border: 2px solid #e8e8e8;
          border-radius: 4px;
          .el-form-item{
            padding: 6px 0;
            .el-input{
              max-width: 100%;
              .el-input__inner{
                border: 0;
              }
            }
            .el-form-item__label-wrap{
              margin-left: 0!important;
            }
            .el-form-item__content{
              margin-left: 68px!important;
              .el-form-item__content{
                margin-left: 0!important;
              }
            }
          }
          :first-child .el-form-item{
            border-bottom: 1px solid #e8e8e8;
          }
        }
        .content-wrap{
          .ql-editor{
            min-height: 400px;
          }
        }
        .el-tabs{
          .el-tab-pane{
            border: 1px solid #e8e8e8;
            border-radius: 0 4px 4px 4px;
          }
        }
      }
      .base-extend-wrap{
        width: 360px;
        .column-form-item{
          margin: 0!important;
          padding: 5px 0;
        }
        .z-draggable-preview{
          >.el-form-item{
            padding: 5px 0;
          }
        }
      }

      .el-collapse-item__wrap{
        overflow: visible;
      }

      .el-collapse{
        border-top: 0;
        .el-collapse-item{
          border: 1px solid #e8e8e8;
          border-radius: 4px;
          padding: 0 20px 30px;
          .el-collapse-item__header {
            border-bottom-color: transparent;
            height: 14px!important;
            font-size: 16px;
            font-weight: 600;
            padding: 30px 0 0;
            &.is-active{
              padding-bottom: 10px;
              border-bottom-color: #e8e8e8;
            }
            .el-collapse-item__arrow{
              font-size: 18px;
            }
          }
          .el-collapse-item__wrap{
            border-bottom: 0;
            .el-collapse-item__content{
              padding-bottom: 0;
              padding-top: 20px;
            }
          }
          & + .el-collapse-item{
            margin-top: 30px;
          }
        }
      }
      .el-picker-panel.el-popper{
        left: auto!important;
        right: 0;
      }
    }
  }

}

</style>
